// extracted by mini-css-extract-plugin
export var root = "cta-module--root--xzkVz";
export var wrapper = "cta-module--wrapper--W53t6";
export var buttons = "cta-module--buttons--4IVCp";